<ng-container *ngIf="product">
  <div class="product">
    <header>
      <div *ngIf="product.has_image" class="img extra">
        <img [src]="product.image_path" class="ya_image">
      </div>
      <div *ngIf="!product.has_image" class="img noimg">
        <h3>{{product.label}}</h3>
      </div>
    </header>
    <div class="content">
      <sot-scroller-vertical>
        <header>
          <h1>{{product.label}}</h1>
          <div class="price">
            {{ extraPrice? (extraPrice | price) : (product.price | price) }}
          </div>
        </header>
        <p *ngIf="product.details.description">{{product.details.description}}</p>
        <sot-properties [product]="product"></sot-properties>
      </sot-scroller-vertical>
    </div>
    <footer class="buttons">
      <div class="buttons">
        <a class="btn goback" (click)="toggleShowInfo()">
          <div inlineSVG="sot/backward.svg" flex [setSVGAttributes]="{class: 'btn-icon'}"></div>
          <span langkey="button_back"></span>
        </a>
      </div>
    </footer>
  </div>
</ng-container>